import { SHOW_MODAL, HIDE_MODAL } from '../constants/ActionTypes';

const initialState = {
  modalType: '',
  modalProps: {}
};

export default function modal(state = initialState, action) {
  switch (action.type) {
    case SHOW_MODAL:
      return {
        modalType: action.modalType,
        modalProps: action.modalProps
      }
    case HIDE_MODAL:
      return initialState
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/reducers/modal.js